module.exports = __webpack_public_path__ + "img/covid19datadetailapp.320b95cf.png";